export default "__VITE_ASSET__BnJPX12B__"